import { signInRedirect } from "@components/Auth/signInRedirect";
import { ROUTES } from "@routing/routes";
import { useAuth } from "@/hooks/useAuth";
import { useSignOut } from "@/hooks/useSignOut";
import { Button } from "@common/index";
import { faRightToBracket } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ComponentSize, ComponentColor } from "@common/types";
import { useAtomValue } from "jotai";
import { currentUserAtom } from "@/store/userAtoms";

export const Login = () => {
    const { isAuthenticated, instance } = useAuth();
    const user = useAtomValue(currentUserAtom);
    const signOut = useSignOut();

    const handleLogin = async () => {
        // Admin-surface login (used only by admin-header): land on the
        // admin root, not the customer app.
        await signInRedirect(instance, ROUTES.ADMIN);
    };

    return (
        <>
            {isAuthenticated ? (
                <div>
                    {user && (
                        <>
                            Welcome, {user!.firstName} {user!.lastName}
                        </>
                    )}
                    <Button color={ComponentColor.Ghost} onClick={signOut}>
                        <FontAwesomeIcon icon={faRightToBracket} /> Logout
                    </Button>
                </div>
            ) : (
                <>
                    <Button color={ComponentColor.Ghost} onClick={handleLogin}>
                        <FontAwesomeIcon icon={faRightToBracket} /> Account
                    </Button>
                    <Button
                        color={ComponentColor.Primary}
                        size={ComponentSize.LG}
                    >
                        Sign Up
                    </Button>
                </>
            )}
        </>
    );
};
